/* tslint:disable */
/* eslint-disable */
/**
 * Brandside Backend API
 * REST API бэкенда Brandside. Авторизация — Bearer-токен Laravel Passport (заголовок Authorization: Bearer token). Успешные ответы оборачиваются в конверт success_response — status: true, data: ...; ошибки — common_error_response — status: false, errors._common: сообщение.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime'
import type { GetSidebarState200ResponseDataApplications } from './GetSidebarState200ResponseDataApplications'
import {
  GetSidebarState200ResponseDataApplicationsFromJSON,
  GetSidebarState200ResponseDataApplicationsFromJSONTyped,
  GetSidebarState200ResponseDataApplicationsToJSON,
} from './GetSidebarState200ResponseDataApplications'
import type { GetSidebarState200ResponseDataRegistriesCount } from './GetSidebarState200ResponseDataRegistriesCount'
import {
  GetSidebarState200ResponseDataRegistriesCountFromJSON,
  GetSidebarState200ResponseDataRegistriesCountFromJSONTyped,
  GetSidebarState200ResponseDataRegistriesCountToJSON,
} from './GetSidebarState200ResponseDataRegistriesCount'

/**
 *
 * @export
 * @interface GetSidebarState200ResponseData
 */
export interface GetSidebarState200ResponseData {
  /**
   *
   * @type {GetSidebarState200ResponseDataApplications}
   * @memberof GetSidebarState200ResponseData
   */
  applications: GetSidebarState200ResponseDataApplications
  /**
   * Временное поле совместимости: количество созданных заявлений на создание товарного знака. Будет удалено после перехода на блок applications
   * @type {number}
   * @memberof GetSidebarState200ResponseData
   * @deprecated
   */
  applicationsCount?: number
  /**
   *
   * @type {GetSidebarState200ResponseDataRegistriesCount}
   * @memberof GetSidebarState200ResponseData
   */
  registriesCount: GetSidebarState200ResponseDataRegistriesCount
  /**
   * Количество отслеживаемых товарных знаков и заявок на них
   * @type {number}
   * @memberof GetSidebarState200ResponseData
   */
  monitoringCount: number
}

/**
 * Check if a given object implements the GetSidebarState200ResponseData interface.
 */
export function instanceOfGetSidebarState200ResponseData(
  value: object
): value is GetSidebarState200ResponseData {
  if (!('applications' in value) || value['applications'] === undefined)
    return false
  if (!('registriesCount' in value) || value['registriesCount'] === undefined)
    return false
  if (!('monitoringCount' in value) || value['monitoringCount'] === undefined)
    return false
  return true
}

export function GetSidebarState200ResponseDataFromJSON(
  json: any
): GetSidebarState200ResponseData {
  return GetSidebarState200ResponseDataFromJSONTyped(json, false)
}

export function GetSidebarState200ResponseDataFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GetSidebarState200ResponseData {
  if (json == null) {
    return json
  }
  return {
    applications: GetSidebarState200ResponseDataApplicationsFromJSON(
      json['applications']
    ),
    applicationsCount:
      json['applicationsCount'] == null ? undefined : json['applicationsCount'],
    registriesCount: GetSidebarState200ResponseDataRegistriesCountFromJSON(
      json['registriesCount']
    ),
    monitoringCount: json['monitoringCount'],
  }
}

export function GetSidebarState200ResponseDataToJSON(
  value?: GetSidebarState200ResponseData | null
): any {
  if (value == null) {
    return value
  }
  return {
    applications: GetSidebarState200ResponseDataApplicationsToJSON(
      value['applications']
    ),
    applicationsCount: value['applicationsCount'],
    registriesCount: GetSidebarState200ResponseDataRegistriesCountToJSON(
      value['registriesCount']
    ),
    monitoringCount: value['monitoringCount'],
  }
}
